import React, { Fragment, Component } from 'react';
import { observer, inject } from 'mobx-react';
import classnames from 'classnames';
import { Paper, IconButton, Menu, MenuItem, withStyles, AppBar, Toolbar, Tooltip, Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Add } from '@material-ui/icons';
import Typography from '@material-ui/core/es/Typography/Typography';
import Movement from '../Dialog/MovementView';
import Patient from '../Dialog/PatientView';
import Devices from '../Dialog/DevicesView';
import Setting from '../Dialog/SettingView';
import CreateAccount from '../Dialog/CreateAccountView';
import ContactPerson from '../Dialog/ContactPersonView';
import ManageGarminAccount from '../Dialog/ManageGarminAccountView';
import Swal from 'sweetalert2';
import { withTranslation } from 'react-i18next';
import { notification } from 'antd';
import { clearLocalStorage } from '../../utils/common';
import SummaryReportPage from '../../pages/summaryReport/SummaryReportPage';
import { getTimeFormatted } from '../../utils/timeFormatted';
import { voteAlert } from '../../utils/voteAlert';
import config from '../../config';

class Widget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogContact: {
        open: false,
      },
      dialogPatient: {
        open: false,
      },
      dialogActivities: {
        open: false,
      },
      dialogMovement: {
        open: false,
      },
      dialogDevice: {
        open: false,
      },
      dialogSetting: {
        open: false,
      },
      dialogGarminAccount: {
        open: false,
      },
      dialogCreateAccount: {
        open: false,
      },
      movement: {
        id: 0,
      },
      devices: {
        list: [],
        selected: 0,
      },
      data: {
        search: false,
        name: '',
        patient: {
          hn: '',
          firstname: '',
          lastname: '',
          firstnameEn: '',
          lastnameEn: '',
          gender: 'M',
          dob: '0000-00-00',
        },
      },
      clearAlert: false,
      // setTooltipOpen: false,
      // setTitleTooltip: ''
    };
    this.handleClickOpenDialogDevice = this.handleClickOpenDialogDevice.bind(this);
    this.handleClickOpenDialogActivities = this.handleClickOpenDialogActivities.bind(this);
    this.handleClickOpenDialogAdd = this.handleClickOpenDialogAdd.bind(this);
    this.handleClickOpenDialogSetting = this.handleClickOpenDialogSetting.bind(this);
    this.handleClickDischage = this.handleClickDischage.bind(this);
    this.handleClickMovement = this.handleClickMovement.bind(this);
    this.handleClickOpenDialogContact = this.handleClickOpenDialogContact.bind(this);
    this.handleClickOpenDialogManageGarminAccount = this.handleClickOpenDialogManageGarminAccount.bind(this);
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    if (nextProps.t !== this.props.t) {
      return true;
    }
    if (JSON.stringify(nextProps.data.patient) !== JSON.stringify(this.props.data.patient)) {
      return true;
    }
    if (JSON.stringify(nextProps.gridPage) !== JSON.stringify(this.props.gridPage)) {
      return true;
    }
    if (JSON.stringify(nextProps.data.roomName) !== JSON.stringify(this.props.data.roomName)) {
      return true;
    }
    if (this.props.isMoreMenuOpen !== nextProps.isMoreMenuOpen) {
      return true;
    }
    if (this.state.dialogDevice.open !== nextState.dialogDevice.open) {
      return true;
    }
    if (this.state.dialogSetting.open !== nextState.dialogSetting.open) {
      return true;
    }
    if (this.state.dialogContact.open !== nextState.dialogContact.open) {
      return true;
    }
    if (this.state.dialogPatient.open !== nextState.dialogPatient.open) {
      return true;
    }
    if (this.state.dialogActivities.open !== nextState.dialogActivities.open) {
      return true;
    }
    if (this.state.dialogMovement.open !== nextState.dialogMovement.open) {
      return true;
    }
    if (this.state.dialogCreateAccount.open !== nextState.dialogCreateAccount.open) {
      return true;
    }
    if (this.state.clearAlert !== nextState.clearAlert) {
      return true;
    }

    return false;
  };

  formatDate(input) {
    // eslint-disable-next-line
    var regex_date = /^\d{4}\-\d{1,2}\-\d{1,2}$/;
    if (regex_date.test(input)) {
      const datePart = input.match(/\d+/g),
        year = +datePart[0] + 543, // get only two digits
        month = datePart[1],
        day = datePart[2];
      return day + '/' + month + '/' + year;
    } else {
      return input;
    }
  }

  initData = async () => {
    if (this.props.data.patient) {
      // this.props.patient.setData(this.props.data);
      let profile = this.props.data;
      profile.patient.dob = this.formatDate(profile.patient.dob);
      this.props.patient.setData(profile);
      this.props.patient.setHnStatus(true);
    } else {
      this.props.patient.setData({
        search: false,
        name: '',
        patient: {
          hn: '',
          firstname: '',
          lastname: '',
          firstnameEn: '',
          lastnameEn: '',
          gender: 'M',
          dob: '',
        },
      });
      this.props.patient.setHnStatus(true);
    }
  };

  clearAlert(data) {
    this.props.dashboard.updateToken();
    this.props.dashboard.clearAlert(data);
    this.setState({
      clearAlert: !this.state.clearAlert,
    });
  }

  acknowledge(data) {
    this.props.dashboard.updateToken();
    this.props.dashboard.ackAlert(data);
  }

  selectBox(data) {
    this.props.logActivity.setId(data.patient.id);
  }

  async chageActivate(data) {
    let device = data.patient.devices;
    device.map((val) => {
      val.status = val.status === 'ACTIVATE_ON' ? 'ACTIVATE_OFF' : 'ACTIVATE_ON';
      return val;
    });
    try {
      await this.props.dashboard.assignDevice(device, data.patient.id);
    } catch (err) {
      notification.error({
        message: `error`,
        description: err.error.message,
        top: '100px',
      });
    }
  }

  handleClickOpenDialogActivities = async (event) => {
    event.preventDefault();
    try {
      this.props.setMoreMenuOpen(false);
      const { data } = this.props;
      if (data && data.patient) {
        this.props.vitalsign.resetVitalSigns();
        this.props.summary.resetSummary(true);
        await this.props.summary.getGraphAvailableDate(data.patient.id);
        this.props.summary.getVitalSignDate(data.patient.id);
        this.props.summary.getAssignedDeviceDate(data.patient.id);
        config.features.report.garmin && this.props.summary.getGarminDate(data.patient.id);
        // this.props.summary.getDeviceUsage(data.patient.id,new Date());

        let queryOption = {};
        if (localStorage.getItem('role_id') === '1') {
          queryOption = {
            activity: true,
            movement: true,
            alert: true,
            location: true,
            battery: true,
            admin: true,
            device: true,
          };
        } else {
          queryOption = {
            activity: true,
            movement: true,
            location: true,
          };
        }

        this.props.summary.getSummary(data.patient.id, new Date(), queryOption);
        const { since } = this.props.vitalsign.toJS();

        const queryLastVitalsign = {
          heartrate: true,
          temperature: true,
          bloodPressure: true,
          spo2: true,
          respirationRate: true,
        };

        const querySummaryVitalsign = {
          heartrate: true,
          temperature: true,
          bloodPressure: true,
          spo2: true,
          respirationRate: true,
          since,
        };

        this.props.summary.getSummaryReport(data.patient.id, new Date());
        this.props.summary.getSummaryReportAsPeriod(data.patient.id, new Date(), 'week', ['sleep', 'event']);
        this.props.summary.getSummaryLocationAsPeriod(data.patient.id, new Date(), 'week');
        this.props.vitalsign.getLastVitalSign(data.patient.id, new Date(), queryLastVitalsign);
        this.props.vitalsign.getSummaryVitalSign(data.patient.id, new Date(), querySummaryVitalsign);
        config.features.report.garmin &&
          this.props.smartwatchsummary.summaryVitalSigns(data.patient.id, new Date(), 'daily', [
            'heartrate',
            'spo2',
            'respiration',
          ]);
      }
      this.setState({ dialogActivities: { open: true } });
    } catch (err) {
      console.log(err);
      throw err;
    }
  };

  handleClickOpenDialogContact = async (event) => {
    event.preventDefault();
    this.props.setMoreMenuOpen(false);
    await this.initData();
    const contactPersons = await this.props.contactperson.findContactPersonByPatientId(this.props.data.patient.id);
    this.props.contactperson.setContactData(contactPersons);
    this.setState({ dialogContact: { open: true } });
  };

  handleClickOpenDialogAdd = async (event) => {
    event.preventDefault();
    this.props.setMoreMenuOpen(false);
    await this.initData();
    this.setState({ dialogPatient: { open: true } });
  };

  handleClickOpenDialogDevice = async (event) => {
    event.preventDefault();
    this.props.setMoreMenuOpen(false);
    try {
      await this.initData();
      this.props.patient.clearSelectDevice();
      this.props.deviceType.setAction('category', null);
      await this.props.deviceType.getCategory();
      // let devices = await this.props.dashboard.getDeviceList();
      // let devicesFilter = devices.filter(device => {
      //   return !device.patientId;
      // });
      // this.props.patient.setDeviceList(devicesFilter);
      this.setState({ dialogDevice: { open: true } });
    } catch (err) {
      notification.error({
        message: `error`,
        description: err.error.message,
        top: '100px',
      });
    }
  };

  handleClickOpenDialogSetting = async (event) => {
    event.preventDefault();
    this.props.setMoreMenuOpen(false);
    const { data } = this.props;
    if (data && data.patient) {
      try {
        await this.props.area.getAreas();
        await this.props.settingProfile.getSettingProfile(0, 0);
        await this.props.setting.getSettingByPatient(data.patient.id);
        this.setState({ dialogSetting: { open: true } });
      } catch (err) {
        notification.error({
          message: `error`,
          description: err.error.message,
          top: '100px',
        });
      }
    }
  };

  handleClickOpenDialogManageGarminAccount = async (event) => {
    event.preventDefault();
    this.props.setMoreMenuOpen(false);
    const { data } = this.props;
    if (data && data.patient) {
      try {
        const queryOption = {
          patient: true,
          device: true,
          tenantIds: data.patient.tenantId ? JSON.stringify([data.patient.tenantId]) : null,
        };
        await this.props.smartwatch.getAllAccounts(queryOption);
        await this.props.smartwatch.getAccountByPatientId(data.patient.id);
        this.setState({ dialogGarminAccount: { open: true } });
      } catch (err) {
        if (err.statusCode === 401) {
          this.signOut();
          window.location.replace('/login');
        } else {
          notification.error({
            message: `error`,
            description: err.error.message,
            top: '100px',
          });
        }
      }
    }
  };

  handleClickDischage = async (event) => {
    event.preventDefault();
    this.props.setMoreMenuOpen(false);
    const { t } = this.props;
    Swal.fire({
      html:
        this.props.data.patient.devices.length > 0
          ? `<h4>${t('discharge_patient')}<h4>${t('discharge_patient2')}`
          : `<h4>${t('sure_to_discharge')}`,
      type: 'warning',
      confirmButtonText: `${t('discharge')}`,
      cancelButtonText: `${t('close')}`,
      showCancelButton: true,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          if (this.props.data.patient.devices.length > 0) {
            for (const data of this.props.data.patient.devices) {
              await this.props.device.unAssignDeviceToPatient(data.id, data.serial);
            }
          }
          await this.props.dashboard.discharge(this.props.data, true);
          this.clearAlert(this.props.data);
          this.clearState('');
        } catch (err) {
          if (err.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            notification.error({
              message: `error`,
              description: err.error.message,
              top: '100px',
            });
          }
        }
      }
    });
  };

  handleClickMovement = async (event) => {
    event.preventDefault();
    this.props.setMoreMenuOpen(false);
    await this.initData();
    this.setState({ dialogMovement: { open: true } });
  };

  handleClickOpenDialogCreateAccount = async (event) => {
    event.preventDefault();
    this.props.setMoreMenuOpen(false);
    const { data } = this.props;
    if (data && data.patient) {
      await this.props.user.getUserPatient(data.patient.id);
      this.setState({ dialogCreateAccount: { open: true } });
    }
  };

  clearState(hn) {
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        patient: {
          hn: hn,
          firstname: '',
          lastname: '',
          firstnameEn: '',
          lastnameEn: '',
          gender: 'M',
          dob: '0000-00-00',
        },
      },
    });
  }

  handleClose = () => {
    this.setState({ dialogContact: { open: false } });
    this.setState({ dialogPatient: { open: false } });
    this.setState({ dialogActivities: { open: false } });
    this.setState({ dialogMovement: { open: false } });
    this.setState({ dialogDevice: { open: false } });
    this.setState({ dialogSetting: { open: false } });
    this.setState({ dialogCreateAccount: { open: false } });
    this.setState({ dialogGarminAccount: { open: false } });
  };

  getRouterPlace = (serial) => {
    const { routers } = this.props.router.toJS();
    const routerData = (routers || []).find((val) => val.serial === serial);
    if (routerData) {
      return routerData.place;
    }
  };

  getRouterArea = (serial) => {
    let { areas } = this.props.area.toJS();

    let name = '';
    (areas.data || []).map((val) => {
      const result = (val.routers || []).find((routers) => routers.serial === serial);
      if (result) {
        name = val.name;
      }
      return val;
    });
    return name;
  };

  getAlertInfo = (value, serial, time, alertAreaName) => {
    const { t } = this.props;
    let result = `${t('unknown')}`;
    switch (value) {
      case 1:
        result = `${t('lying')}`;
        break;
      case 2:
        result = `${t('sitting')}`;
        break;
      case 3:
        result = `${t('standing')}`;
        break;
      case 4:
        result = `${t('walking')}`;
        break;
      case 5:
        result = `${t('Running')}`;
        break;
      case 6:
        result = `${t('Jumping')}`;
        break;
      case 7:
        result = `${t('lying_on_back')}`;
        break;
      case 8:
        result = `${t('lying_on_stomach')}`;
        break;
      case 9:
        result = `${t('lying_on_left_side')}`;
        break;
      case 10:
        result = `${t('lying_on_right_side')}`;
        break;
      case 501:
        result = `${t('get_up')}`;
        break;
      case 502:
        result = `${t('movement')}`;
        break;
      case 503:
        result = `${t('low_battery')}`;
        break;
      case 504:
        result = `${t('alert_last_seen')} @ ${this.getRouterPlace(serial)}`;
        break;
      case 505:
        result = `${t('alert_router_no_signal')}`;
        break;
      case 506:
        result = `${t('alert_not_turn')}`;
        break;
      case 507:
        let numberOfDay = time / 60 / 24;
        let dayFormat = `${numberOfDay === 1 ? numberOfDay + ' ' + t('day') : numberOfDay + ' ' + t('days')}`;
        result = `${t('alert_no_movement')} > ${numberOfDay === 0 ? '' : dayFormat}`;
        break;
      case 508:
        result = `${t('alert_fall')} @ ${this.getRouterPlace(serial)}`;
        break;
      case 509:
        result = ` @ ${t('alert_exit')} ${alertAreaName ? alertAreaName : this.getRouterArea(serial)}`;
        break;
      case 510:
        result = ` @ ${alertAreaName ? alertAreaName : this.getRouterArea(serial)}`;
        break;
      case 511:
        result = `${t('alert_walking')} @ ${this.getRouterPlace(serial)}`;
        break;
      case 512:
        result = `${t('alert_deactivate_recharge')}`;
        break;
      case 513:
        result = `${t('alert_bad_signal')}`;
        break;
      case 514:
        result = `${t('alert_emergency_alarm')} ${
          config.displayPlaceForEmergency ? `@ ${this.getRouterPlace(serial)}` : ''
        }`;
        break;
      default:
        break;
    }
    return result;
  };

  isMuted = (userWithAlert) => {
    let muteNotification = localStorage.getItem('mute_notification');
    muteNotification = muteNotification ? JSON.parse(muteNotification) : [];
    const mutePatient = muteNotification.find((val) => val.patientId === userWithAlert.patientId);
    if (mutePatient) {
      if (
        userWithAlert &&
        userWithAlert.patient &&
        userWithAlert.patient.devices &&
        userWithAlert.patient.devices.length > 0
      ) {
        const alertIds = [];
        userWithAlert.patient.devices.forEach((d) => {
          if (d.action && d.action.alerts.length > 0) {
            d.action.alerts.forEach((a) => {
              if (a.alertId && a.alertType !== 513) {
                alertIds.push(a.alertId);
              }
            });
          }
        });
        const newAlertIds = alertIds.filter((x) => !(mutePatient.alertId || []).includes(x));

        return newAlertIds.length === 0 ? true : false;
      }
    }
    return false;
  };

  isEmergencyButton = (devices) => {
    for (const device of devices || []) {
      const { deviceVersion } = device;
      if (deviceVersion) {
        const property = deviceVersion.property ? JSON.parse(deviceVersion.property) : null;
        if (property) {
          if (property.alarmTrigger || property.alarmOnoff) {
            return true;
          }
        }
      }
    }
    return false;
  };

  isEmergencyDevice = (device) => {
    const { deviceVersion } = device;
    if (deviceVersion) {
      const property = deviceVersion.property ? JSON.parse(deviceVersion.property) : null;
      if (property) {
        if (property.alarmTrigger || property.alarmOnoff) {
          return true;
        }
      }
    }
    return false;
  };

  hasReport(devices, reportType) {
    const found = devices.filter((d) => {
      if (!d.deviceVersion) {
        return false;
      }
      const deviceProperty = d.deviceVersion['property'] ? JSON.parse(d.deviceVersion['property']) : null;
      if (deviceProperty) {
        return deviceProperty[reportType] === 1;
      }

      return false;
    });
    return found.length > 0;
  }

  getCurrentAssignedDevice = (devices) => {
    return {
      assignedDevices: devices && devices.length > 0 ? devices.map((v) => v.name) : [],
      reportOptions: {
        hasActivity: devices && devices.length > 0 ? this.hasReport(devices, 'motionTracker') : true,
        hasLocalization: devices && devices.length > 0 ? this.hasReport(devices, 'localization') : true,
      },
    };
  };

  render() {
    const {
      classes,
      children,
      // title,
      noBodyPadding,
      bodyClass,
      // disableWidgetMenu,
      data,
      gridPage,
      hasPatient,
      t,
    } = this.props;
    let title = data.roomName && data.name ? `${data.roomName}/${data.name}` : data.roomName || data.name;

    const showActivateButton =
      data.patient &&
      data.patient.devices &&
      data.patient.devices
        .map((value) => (value.deviceVersion ? JSON.parse(value.deviceVersion.property).activateButton : 0))
        .some((value) => value);
    const showAlertSetting = data.patient && data.patient.devices && data.patient.devices.length > 0;

    const alert = voteAlert(data.patient);
    const { votedAlert } = alert;
    const time = votedAlert && votedAlert.warningSetting.noMovementForTime;
    const alertType = votedAlert && votedAlert.alertType;
    const routerSerial = votedAlert && votedAlert.routerSerial;
    const alertAreaName = votedAlert && votedAlert.alertAreaName;

    const tmp = (
      <div className={config.features.dashboard.roomName ? classes.widgetWrapper : classes.widgetWrapWithOutRoomName}>
        <Paper className={classes.paper} classes={{ root: classes.widgetRoot }}>
          <div className={classes.widgetHeader}>
            {config.features.dashboard.roomName && (
              <Fragment>
                {gridPage === 2 && (
                  <AppBar position='static' className={classes.headerToolbar}>
                    <Tooltip
                      classes={{ tooltip: classes.tooltipFont }}
                      className={classes.customizeToolbar}
                      title={title}
                      interactive
                      open={title.length > 12 ? null : false}
                      PopperProps={{
                        popperOptions: {
                          modifiers: {
                            offset: {
                              enabled: true,
                              offset: '0px, -20px',
                            },
                          },
                        },
                      }}
                    >
                      <Typography className={classes.titleRoom}>{title}</Typography>
                    </Tooltip>
                  </AppBar>
                )}
                {(gridPage === 3 || gridPage === 4) && (
                  <AppBar position='static' className={classes.headerToolbar}>
                    <Tooltip
                      classes={{ tooltip: classes.tooltipFont }}
                      className={classes.customizeToolbar}
                      title={title}
                      interactive
                      open={title.length > 12 ? null : false}
                      PopperProps={{
                        popperOptions: {
                          modifiers: {
                            offset: {
                              enabled: true,
                              offset: '0px, -20px',
                            },
                          },
                        },
                      }}
                    >
                      <Typography className={classes.titleRoom}>{title}</Typography>
                    </Tooltip>
                  </AppBar>
                )}
              </Fragment>
            )}
            {/* {this.props.header ? (
              this.props.header
            ) : (
              <Fragment>
                {gridPage === 2 && (
                  <AppBar position="static" className={classes.headerToolbar}>
                    <Tooltip
                      classes={{ tooltip: classes.tooltipFont }}
                      className={classes.customizeToolbar}
                      title={title}
                      interactive
                      open={title.length > 12 ? null : false}
                      PopperProps={{
                        popperOptions: {
                          modifiers: {
                            offset: {
                              enabled: true,
                              offset: "0px, -20px",
                            },
                          },
                        },
                      }}
                    >
                      <Typography className={classes.titleRoom}>
                        {title}
                      </Typography>
                    </Tooltip>
                  </AppBar>
                )}
                {(gridPage === 3 || gridPage === 4) && (
                  <AppBar position="static" className={classes.headerToolbar}>
                    <Tooltip
                      classes={{ tooltip: classes.tooltipFont }}
                      className={classes.customizeToolbar}
                      title={title}
                      interactive
                      open={title.length > 12 ? null : false}
                      PopperProps={{
                        popperOptions: {
                          modifiers: {
                            offset: {
                              enabled: true,
                              offset: "0px, -20px",
                            },
                          },
                        },
                      }}
                    >
                      <Typography className={classes.titleRoom}>
                        {title}
                      </Typography>
                    </Tooltip>
                  </AppBar>
                )}
              </Fragment>
            )} */}
          </div>
          <div
            className={classnames(classes.widgetBody, {
              [classes.noPadding]: noBodyPadding,
              [bodyClass]: bodyClass,
            })}
          >
            {!hasPatient && (
              <div
                className={
                  localStorage.getItem('role_id') === '1' && gridPage === 2 ? classes.noPatientGrid : classes.noPatient
                }
              >
                <Button
                  // variant="outlined"
                  size='small'
                  color='primary'
                  onClick={this.handleClickOpenDialogAdd}
                  className={classes.addPatient}
                  id='admitPatientBtn'
                >
                  <Add /> {t('admit_patient')}
                </Button>
              </div>
            )}
            {children}
          </div>
          <div>
            <AppBar
              position='static'
              className={
                votedAlert && votedAlert.alertCritical === 'true'
                  ? classes.footerCritical
                  : votedAlert &&
                      votedAlert.alertWarning === 'true' &&
                      ![503, 504, 512, 513].includes(votedAlert.alertType)
                    ? classes.footerWarning
                    : votedAlert &&
                        votedAlert.alertWarning === 'true' &&
                        [503, 504, 512, 513].includes(votedAlert.alertType)
                      ? classes.footerInfo
                      : classes.footer
              }
            >
              <Tooltip
                classes={{ tooltip: classes.tooltipFont }}
                interactive
                title={
                  votedAlert && (votedAlert.alertWarning === 'true' || votedAlert.alertCritical === 'true')
                    ? getTimeFormatted(votedAlert.alertTime, t)
                    : ''
                }
                PopperProps={{
                  popperOptions: {
                    modifiers: {
                      offset: {
                        enabled: true,
                        offset: '0px, -20px',
                      },
                    },
                  },
                }}
              >
                <Toolbar className={classes.footerToolbar}>
                  <Grid container>
                    <div className={gridPage === 2 ? classes.alertInfoGrid6 : classes.alertInfoGrid4}>
                      {votedAlert && votedAlert.alertCritical === 'true' ? (
                        <Typography
                          color='inherit'
                          id='alertinfo'
                          className={
                            localStorage.getItem('role_id') === '1' && gridPage === 2
                              ? classnames(classes.fontgrid, classes.hiddenText)
                              : classnames(classes.fontAlert, classes.hiddenText)
                          }
                        >
                          {this.getAlertInfo(alertType, routerSerial, time, alertAreaName)}
                        </Typography>
                      ) : votedAlert &&
                        votedAlert.alertWarning === 'true' &&
                        ![503, 504, 512, 513].includes(votedAlert.alertType) ? (
                        <Typography
                          id='alertinfo'
                          // variant="caption"
                          color='inherit'
                          className={
                            localStorage.getItem('role_id') === '1' && gridPage === 2
                              ? classnames(classes.fontgrid, classes.hiddenText)
                              : classnames(classes.fontAlert, classes.hiddenText)
                          }
                        >
                          {this.getAlertInfo(alertType, routerSerial, time, alertAreaName)}
                        </Typography>
                      ) : votedAlert &&
                        votedAlert.alertWarning === 'true' &&
                        [503, 504, 512, 513].includes(votedAlert.alertType) ? (
                        <Typography
                          id='alertinfo'
                          variant='caption'
                          color='inherit'
                          className={
                            localStorage.getItem('role_id') === '1' && gridPage === 2
                              ? classnames(classes.fontgrid, classes.hiddenText)
                              : classnames(classes.fontAlert, classes.hiddenText)
                          }
                        >
                          {this.getAlertInfo(alertType, routerSerial, time, alertAreaName)}
                          {/* {t("no_signal")} */}
                        </Typography>
                      ) : (
                        ''
                      )}
                    </div>
                    <div className={gridPage === 2 ? classes.alertInfoIconGrid6 : classes.alertInfoIconGrid4}>
                      {votedAlert &&
                        (votedAlert.alertWarning === 'true' || votedAlert.alertCritical === 'true') &&
                        !this.isMuted(data) && (
                          <IconButton
                            classes={{ root: classes.btnMute }}
                            aria-label='delete'
                            id='clear'
                            onClick={() => this.clearAlert(data)}
                          >
                            <svg
                              width='26'
                              height='26'
                              viewBox='0 0 26 26'
                              className={
                                votedAlert && votedAlert.alertCritical === 'true'
                                  ? classes.btnCritical
                                  : votedAlert &&
                                      votedAlert.alertWarning === 'true' &&
                                      ![503, 504, 512, 513].includes(votedAlert.alertType)
                                    ? classes.btnWarnning
                                    : votedAlert &&
                                        votedAlert.alertWarning === 'true' &&
                                        [503, 504, 512, 513].includes(votedAlert.alertType)
                                      ? classes.btnInfo
                                      : ''
                              }
                            >
                              <use xlinkHref={`/images/menus-v1.svg#mutealert`} />
                            </svg>
                          </IconButton>
                        )}
                      {data.alert && data.alert.acknowledge === true && (
                        <IconButton
                          classes={{ root: classes.btnAck }}
                          aria-label='delete'
                          id='acknowledge'
                          onClick={() => this.acknowledge(data)}
                        >
                          <svg
                            width='21'
                            height='21'
                            viewBox='0 0 21 21'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                            className={
                              votedAlert && votedAlert.alertCritical === 'true'
                                ? classes.btnAckCritical
                                : votedAlert &&
                                    votedAlert.alertWarning === 'true' &&
                                    ![503, 504, 512, 513].includes(votedAlert.alertType)
                                  ? classes.btnAckWarnning
                                  : votedAlert &&
                                      votedAlert.alertWarning === 'true' &&
                                      [503, 504, 512, 513].includes(votedAlert.alertType)
                                    ? classes.btnAckInfo
                                    : ''
                            }
                          >
                            <path d='M6.5 11L9 14L15.5 6' strokeWidth='1.5' />
                          </svg>
                        </IconButton>
                      )}
                    </div>
                  </Grid>
                </Toolbar>
              </Tooltip>
            </AppBar>
          </div>
        </Paper>
        {data && hasPatient && (
          <Menu
            id='widget-menu'
            open={this.props.isMoreMenuOpen}
            anchorEl={this.props.moreButtonRef}
            onClose={() => this.props.setMoreMenuOpen(false)}
            disableAutoFocusItem
          >
            {showActivateButton && (
              <div>
                <MenuItem onClick={() => this.chageActivate(data)}>
                  <Typography>
                    {(data.patient.devices && data.patient.devices.length > 0 && data.patient.devices[0].status) ===
                    'ACTIVATE_ON'
                      ? t('off')
                      : t('on')}
                  </Typography>
                </MenuItem>
                <hr className={classes.dialogMenu} />
              </div>
            )}

            <MenuItem onClick={this.handleClickOpenDialogDevice}>
              <Typography>{t('manage_devices')}</Typography>
            </MenuItem>
            <MenuItem onClick={this.handleClickOpenDialogSetting} disabled={showAlertSetting ? false : true}>
              <Typography>{t('alert_setting')}</Typography>
            </MenuItem>
            <hr className={classes.dialogMenu} />
            {config.features.report.garmin && (
              <MenuItem onClick={this.handleClickOpenDialogManageGarminAccount}>
                <Typography>{t('manage_garmin_account')}</Typography>
              </MenuItem>
            )}
            <MenuItem onClick={this.handleClickOpenDialogCreateAccount}>
              <Typography>{t('manage_myactsense_account')}</Typography>
            </MenuItem>
            <hr className={classes.dialogMenu} />

            <MenuItem
              onClick={this.handleClickOpenDialogAdd}
              // disabled={config.features.allPatients.syncNirun}
            >
              <Typography>{t('edit_patient')}</Typography>
            </MenuItem>

            <MenuItem
              onClick={this.handleClickOpenDialogContact}
              // disabled={config.features.allPatients.syncNirun}
            >
              <Typography>{t('edit_contact_info')}</Typography>
            </MenuItem>

            <MenuItem onClick={this.handleClickMovement}>
              <Typography>{t('move_patient')}</Typography>
            </MenuItem>
            <MenuItem onClick={this.handleClickDischage}>
              <Typography>{t('discharge')}</Typography>
            </MenuItem>
            <hr className={classes.dialogMenu} />

            <MenuItem onClick={this.handleClickOpenDialogActivities}>
              <Typography>{t('summary_report')}</Typography>
            </MenuItem>
          </Menu>
        )}

        {data && this.state.dialogContact.open && (
          <ContactPerson props={this.props} state={this.state} patient={data.patient} handleClose={this.handleClose} />
        )}
        {data && this.state.dialogPatient.open && (
          <Patient props={this.props} state={this.state} handleClose={this.handleClose} />
        )}
        {hasPatient && (
          <Fragment>
            {this.state.dialogActivities.open && (
              // <Activities
              //   patientId={data.patient.id}
              //   firstname={data.patient.firstname}
              //   lastname={data.patient.lastname}
              //   firstnameEn={data.patient.firstnameEn}
              //   lastnameEn={data.patient.lastnameEn}
              //   open={this.state.dialogActivities.open}
              //   handleClose={this.handleClose}
              //   devices={data.patient.devices}
              //   // data={data}
              // />
              <SummaryReportPage
                open={this.state.dialogActivities.open}
                handleClose={this.handleClose}
                data={data}
                isEmergency={this.isEmergencyButton(data.patient.devices)}
                currentAssignedDevice={this.getCurrentAssignedDevice(data.patient.devices)}
                // alertType={alertType}
              />
            )}
            {this.state.dialogMovement.open && (
              <Movement props={this.props} state={this.state} handleClose={this.handleClose} />
            )}
            {this.state.dialogDevice.open && (
              <Devices
                // props={this.props}
                patientData={data}
                state={this.state}
                handleClose={this.handleClose}
              />
            )}
            {this.state.dialogSetting.open && (
              <Setting props={this.props} state={this.state} handleClose={this.handleClose} />
            )}
            {this.state.dialogCreateAccount.open && (
              <CreateAccount props={this.props} state={this.state} handleClose={this.handleClose} />
            )}
            {this.state.dialogGarminAccount.open && (
              <ManageGarminAccount
                patientData={data}
                state={this.state}
                handleClose={this.handleClose}
                pathName={this.props.location.pathname}
              />
            )}
          </Fragment>
        )}
      </div>
    );
    // console.timeEnd('widget')
    return tmp;
  }
}

const styles = (theme) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
  },
  appBar: {
    position: 'relative',
  },
  title: {
    flex: 1,
  },
  contentTitle: {
    float: 'left',
    color: 'white',
  },
  input: {
    marginLeft: 8,
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: '100%',
  },
  formSelect: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit,
    minWidth: 130,
    maxWidth: '100%',
  },
  selectOption: {
    '& fieldset': {
      top: '-2px',
      bottom: '2px',
    },
    '& svg': {
      top: 'calc(50% - 8px)',
    },
    '& select': {
      paddingTop: '17px',
      paddingBottom: '5px',
    },
    '&:hover, &:focus': {
      borderColor: `${theme.palette.primary.main} !important`,
    },
  },
  widgetWrapper: {
    display: 'flex',
    // minHeight: '100%',
    minHeight: '160px',
  },
  widgetWrapWithOutRoomName: {
    display: 'flex',
    // minHeight: '100%',
    minHeight: '146px',
  },
  widgetHeader: {
    // padding: theme.spacing.unit * 0.4,
    paddingBottom: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  widgetRoot: {
    boxShadow: theme.customShadows.widget,
  },
  widgetBody: {
    padding: theme.spacing.unit * 0.5,
  },
  noPadding: {
    padding: 0,
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden',
  },
  paperCritical: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden',
  },
  paperWarning: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden',
  },
  paperInfo: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    overflow: 'hidden',
  },
  customizeToolbar: {
    minHeight: '24px',
    paddingLeft: '8px',
    paddingRight: '12px',
  },
  footerToolbar: {
    minHeight: '30px',
    paddingLeft: '20px',
    paddingRight: '12px',
  },
  headerToolbar: {
    flexGrow: 1,
    display: 'flex',
    backgroundColor: theme.palette.background.header,
    boxShadow: 'none',
  },
  footer: {
    flexGrow: 1,
    display: 'flex',
    backgroundColor: theme.palette.background.footer,
    // backgroundColor: "white",
    boxShadow: 'none',
  },
  footerCritical: {
    flexGrow: 1,
    display: 'flex',
    backgroundColor: theme.palette.error.main,
    color: 'white !important',
    fontSize: 14,
  },
  footerWarning: {
    flexGrow: 1,
    display: 'flex',
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.text.secondary,
    fontSize: 14,
  },
  footerInfo: {
    flexGrow: 1,
    display: 'flex',
    backgroundColor: theme.palette.info.main,
    color: 'white !important',
  },
  buttonBox: {
    marginRight: 5,
  },
  moreButton: {
    padding: 0,
    width: 21,
    height: 21,
    margin: 2,
    color: theme.palette.success.main,
    backgroundColor: theme.palette.primary.bg,
    '&:hover': {
      backgroundColor: theme.palette.primary.hover,
    },
  },
  btnMute: {
    padding: 0,
    width: 24,
    height: 24,
    marginRight: 3,
    color: 'white',
    backgroundColor: 'rgb(255, 255, 255, 0.5)',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  btnAck: {
    padding: 0,
    width: 24,
    height: 24,
    color: 'white',
    backgroundColor: 'rgb(255, 255, 255, 0.5)',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  btnAckCritical: {
    width: 22,
    stroke: 'white',
    '&:hover': {
      stroke: theme.palette.error.main,
    },
  },
  btnAckWarnning: {
    width: 22,
    stroke: theme.palette.text.secondary,
    '&:hover': {
      stroke: theme.palette.text.secondary,
    },
  },
  btnAckInfo: {
    width: 22,
    stroke: 'white',
    '&:hover': {
      stroke: theme.palette.info.main,
    },
  },
  btnCritical: {
    width: 22,
    fill: 'white',
    stroke: 'white',
    '&:hover': {
      fill: theme.palette.error.main,
      stroke: theme.palette.error.main,
    },
  },
  btnWarnning: {
    width: 22,
    fill: theme.palette.text.secondary,
    stroke: theme.palette.text.secondary,
    '&:hover': {
      fill: theme.palette.text.secondary,
      stroke: theme.palette.text.secondary,
    },
  },
  btnInfo: {
    width: 22,
    fill: 'white',
    stroke: 'white',
    '&:hover': {
      fill: theme.palette.info.main,
      stroke: theme.palette.info.main,
    },
  },
  formInput: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    '& label': {
      transform: 'translate(0px, 7px) scale(0.7) !important',
      fontSize: '1.33rem !important',
      width: 'max-content',
    },
  },
  textfield: {
    '& fieldset': {
      top: '4px',
      bottom: '6px',
    },
    '& input': {
      marginLeft: '-2px',
    },
    '& label': {
      marginLeft: '2px',
    },
    width: '100%',
    minWidth: 145,
    paddingRight: '12px',
    paddingLeft: '4px',
  },
  textLabelSelect: {
    marginTop: '5px',
  },
  fontAlert: {
    fontSize: '14px',
    fontWeight: 500,
  },
  fontgrid: {
    fontSize: '14px',
    fontWeight: 500,
  },
  hiddenText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  noPatient: {
    textAlign: 'center',
    paddingTop: '40px',
    paddingBottom: '26px',
    minHeight: '100px',
  },
  noPatientGrid: {
    textAlign: 'center',
    paddingTop: '40px',
    paddingBottom: '23px',
  },
  titleRoom: {
    fontSize: '16px',
    fontWeight: '600',
    color: theme.palette.success.main,
  },

  chipSidebarOpened: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#fff',
    marginLeft: '-10px',
    marginTop: '-5px',
    borderRadius: '0 0 10px 0',
    maxWidth: '35%',
  },
  chip: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#fff',
    marginLeft: '-10px',
    marginTop: '-5px',
    borderRadius: '0 0 10px 0',
    maxWidth: '40%',
  },
  chipLabel: {
    display: 'inline',
    overflow: 'hidden',
    // textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  addPatient: {
    fontSize: '14px',
    fontWeight: '500',
    borderColor: 'rgb(224, 224, 224)',
    color: theme.palette.success.main,
  },
  SettingList: {
    width: '100%',
    display: 'flex',
    position: 'relative',
    justifyContent: 'flex-start',
    textAlign: 'left',
    paddingBottom: 0,
    paddingTop: 0,
  },
  dialogMenu: {
    backgroundColor: 'rgba(9,30,66,0.13)',
    border: 0,
    height: '1px',
    margin: '11px',
    padding: 0,
    width: '84%',
  },
  RadioGroup: {
    marginTop: '-12px',
  },
  tooltipFont: {
    fontSize: '15px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  positionPaper: {
    position: 'relative',
    marginTop: '-10px',
    zIndex: 1400,
  },
  patientMenuItem: {
    width: '100%',
    maxHeight: 200,
    overflow: 'auto',
  },
  alertInfoGrid4: {
    width: '80%',
  },
  alertInfoIconGrid4: {
    width: '20%',
    display: 'flex',
    justifyContent: 'right',
  },
  alertInfoGrid6: {
    width: '70%',
    [theme.breakpoints.up('xl')]: {
      width: '80%',
    },
  },
  alertInfoIconGrid6: {
    width: '30%',
    display: 'flex',
    justifyContent: 'right',
    [theme.breakpoints.up('xl')]: {
      width: '20%',
    },
  },
});

export const page = inject(
  'dashboard',
  'patient',
  'setting',
  'event',
  'device',
  'logActivity',
  'settingProfile',
  'area',
  'router',
  'summary',
  'vitalsign',
  'deviceType',
  'contactperson',
  'smartwatch',
  'smartwatchsummary',
  'user',
)(observer(Widget));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
